/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_Step_OneInputs */

const en_directory_guide_how_it_works_step_one = /** @type {(inputs: Directory_Guide_How_It_Works_Step_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit the product name, website, short description, and category.`)
};

const zh_directory_guide_how_it_works_step_one = /** @type {(inputs: Directory_Guide_How_It_Works_Step_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写产品名称、网站、简短描述和分类。`)
};

/**
* | output |
* | --- |
* | "Submit the product name, website, short description, and category." |
*
* @param {Directory_Guide_How_It_Works_Step_OneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_step_one = /** @type {((inputs?: Directory_Guide_How_It_Works_Step_OneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_Step_OneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_step_one(inputs)
	return zh_directory_guide_how_it_works_step_one(inputs)
});
export { directory_guide_how_it_works_step_one as "directory.guide.how_it_works.step_one" }